import qs from 'qs'
import axios from 'axios'

export const notificationService = ({
  sendM365PushNotification (token, notifObj) {
    // var stringifiedObj = qs.stringify(notifObj)
    return axios.post('/api/Notification/SendM365PushNotification', notifObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getScheduleNotification (token, notifObj) {
    var stringifiedObj = qs.stringify(notifObj)
    return axios.post('/api/Notification/ViewScheduledNotification', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteScheduledNotification (token, notifObj) {
    return axios.delete('/api/Notification/CancelScheduledNotification', {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}, data: notifObj})
  },
  getUserList (token, scheduledNotificationId) {
    return axios.get('/api/Notification/ScheduledNotificationUsers?scheduledNotificationId=' + scheduledNotificationId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateScheduledNotification (token, notifObj) {
    var stringifiedObj = qs.stringify(notifObj)
    return axios.put('/api/Notification/UpdateScheduledNotification', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  }

})



// WEBPACK FOOTER //
// ./src/server-util/notification-service.js